import {
	Checkbox,
	Col,
	Form,
	Image,
	Input,
	Row,
	Typography,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
const { Text, Title } = Typography;

const ProductionCheckInView = ({ productionId }) => {
	const [form] = Form.useForm();
	const [loadingButton, setLoadingButton] = useState(true);
	const [initialValues, setInitialValues] = useState({});
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getProduction();
	}, []);

	const getProduction = async () => {
		try {
			setLoadingButton(true);

			const url = api + `/production/eticket/${productionId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;
				setInitialValues({
					mainPowerOK: payload.mainPower,
					mainPowerNOK: !payload.mainPower,
					mainPowerComment: payload.mainPowerComment,
					controllerFunctionalOK: payload.controllerFunctional,
					controllerFunctionalNOK: !payload.controllerFunctional,
					controllerFunctionalComment: payload.controllerFunctionalComment,
					cpuFunctionalOK: payload.cpuFunctional,
					cpuFunctionalNOK: !payload.cpuFunctional,
					cpuFunctionalComment: payload.cpuFunctionalComment,
					waterValvesOK: payload.waterValves,
					waterValvesNOK: !payload.waterValves,
					waterValvesComment: payload.waterValvesComment,
					airLeaksOK: payload.airLeaks,
					airLeaksNOK: !payload.airLeaks,
					airLeaksComment: payload.airLeaksComment,
					materialGatesOK: payload.materialGates,
					materialGatesNOK: !payload.materialGates,
					materialGatesComment: payload.materialGatesComment,
					oilCompressorOK: payload.oilCompressor,
					oilCompressorNOK: !payload.oilCompressor,
					oilCompressorComment: payload.oilCompressorComment,
					airCompressorPressureOK: payload.airCompressorPressure,
					airCompressorPressureNOK: !payload.airCompressorPressure,
					airCompressorPressureComment: payload.airCompressorPressureComment,
					plantDispensesOK: payload.plantDispenses,
					plantDispensesNOK: !payload.plantDispenses,
					plantDispensesComment: payload.plantDispensesComment,
					bandRotatesOK: payload.bandRotates,
					bandRotatesNOK: !payload.bandRotates,
					bandRotatesComment: payload.bandRotatesComment,
					chemicaLevelOK: payload.chemicaLevel,
					chemicaLevelNOK: !payload.chemicaLevel,
					chemicaLevelComment: payload.chemicaLevelComment,
					reviewVibratorsOK: payload.reviewVibrators,
					reviewVibratorsNOK: !payload.reviewVibrators,
					reviewVibratorsComment: payload.reviewVibratorsComment,
					cementGateOK: payload.cementGate,
					cementGateNOK: !payload.cementGate,
					cementGateComment: payload.cementGateComment,
					reviewChillersOK: payload.reviewChillers,
					reviewChillersNOK: !payload.reviewChillers,
					reviewChillersTemperature: payload.reviewChillersTemperature,
					gravelHumidityOK: payload.gravelHumidity,
					gravelHumidityNOK: !payload.gravelHumidity,
					gravelHumidityTemperature: payload.gravelHumidityTemperature,
					humidityProcessOK: payload.humidityProcess,
					humidityProcessNOK: !payload.humidityProcess,
					humidityProcessPercentage: payload.humidityProcessPercentage,
					silotopFiltersOK: payload.silotopFilters,
					silotopFiltersNOK: !payload.silotopFilters,
					silotopFiltersComment: payload.silotopFiltersComment,
					airTankPurgeOK: payload.airTankPurge,
					airTankPurgeNOK: !payload.airTankPurge,
					airTankPurgeComment: payload.airTankPurgeComment,
					bandConditionOK: payload.bandCondition,
					bandConditionNOK: !payload.bandCondition,
					bandConditionComment: payload.bandConditionComment,
					verificationGallonsOK: payload.verificationGallons,
					verificationGallonsNOK: !payload.verificationGallons,
					verificationGallonsComment: payload.verificationGallonsComment,
					checkbeltrollerUrlsOK: payload.checkbeltrollerUrls.length !== 0,
					checkbeltrollerUrlsNOK: payload.checkbeltrollerUrls.length === 0,
					checkbeltrollerUrls: payload.checkbeltrollerUrls,
					accumulatedmaterialUrlsOK:
						payload.accumulatedmaterialUrls.length !== 0,
					accumulatedmaterialUrlsNOK:
						payload.accumulatedmaterialUrls.length === 0,
					accumulatedmaterialUrls: payload.accumulatedmaterialUrls,
					cleaningresidueUrlsOK: payload.cleaningresidueUrls.length !== 0,
					cleaningresidueUrlsNOK: payload.cleaningresidueUrls.length === 0,
					cleaningresidueUrls: payload.cleaningresidueUrls,
					checkLubricationOK: payload.checkLubrication,
					checkLubricationNOK: !payload.checkLubrication,
					checkLubricationComment: payload.checkLubricationComment,
					checkVibratorsOK: payload.checkVibrators,
					checkVibratorsNOK: !payload.checkVibrators,
					checkVibratorsComment: payload.checkVibratorsComment,
					airCompressorsOK: payload.airCompressors,
					airCompressorsNOK: !payload.airCompressors,
					airCompressorsComment: payload.airCompressorsComment,
					checkWorkLightsOK: payload.checkWorkLights,
					checkWorkLightsNOK: !payload.checkWorkLights,
					checkWorkLightsComment: payload.checkWorkLightsComment,
					sandVolumeOK: payload.sandVolume,
					sandVolumeNOK: !payload.sandVolume,
					sandVolumeQuantity: payload.sandVolumeQuantity,
					gravelVolumeOK: payload.gravelVolume,
					gravelVolumeNOK: !payload.gravelVolume,
					gravelVolumeQuantity: payload.gravelVolumeQuantity,
					cementVolumeOK: payload.cementVolume,
					cementVolumeNOK: !payload.cementVolume,
					cementVolumeQuantity: payload.cementVolumneQuantity,
					fullCementSilosOK: payload.fullCementSilos,
					fullCementSilosNOK: !payload.fullCementSilos,
					fullCementSilosComment: payload.fullCementSilosComment,
					functionalSlumpRackOK: payload.functionalSlumpRack,
					functionalSlumpRackNOK: !payload.functionalSlumpRack,
					functionalSlumpRackComment: payload.functionalSlumpRackComment,
					chemicaInventoryOK: payload.chemicaInventory,
					chemicaInventoryNOK: !payload.chemicaInventory,
					chemicaInventoryComment: payload.chemicaInventoryComment,
					nr: payload.nr,
					se: payload.se,
					sika440: payload.sika440,
					sika500: payload.sika500,
					sika1000: payload.sika1000,
					cogsPost: payload.cogsPost.map((item) => ({
						quantity: item.quantity,
						material: item.cog.material,
						unitOfConversion: item.cog.unitOfConversion,
					})),
				});
				setLoadingButton(false);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to add lien comment"
			);
			console.error(err.message);
			return null;
		}
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Row gutter={16} justify={"space-between"}>
							<Col span={8}>
								<Text strong>Description / Additional Description</Text>
							</Col>
							<Col span={8}>
								<Text strong>Comments</Text>
							</Col>
							<Col>
								<Row gutter={16} justify={"end"}>
									<Col>
										<Text strong>OK</Text>
									</Col>
									<Col>
										<Text strong>NOK</Text>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
				<Title
					level={4}
					type="danger"
					style={{ paddingBottom: 20, paddingTop: 20 }}
				>
					PRE
				</Title>
				<Row gutter={16}>
					<ItemChecked
						ok={"mainPowerOK"}
						nok={"mainPowerNOK"}
						text={"mainPowerComment"}
						title={"The main power is on and is in good condition"}
						description={"If it is off, you need to turn it on."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"controllerFunctionalOK"}
						nok={"controllerFunctionalNOK"}
						text={"controllerFunctionalComment"}
						title={"The controller is on and functional"}
						description={"If it is off, you need to turn it on."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"cpuFunctionalOK"}
						nok={"cpuFunctionalNOK"}
						text={"cpuFunctionalComment"}
						title={"The CPU is on and functional"}
						description={"If it is off, you need to turn it on."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"waterValvesOK"}
						nok={"waterValvesNOK"}
						text={"waterValvesComment"}
						title={"The water valves are open properly"}
						description={"Open and close the faucets if necessary."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"airLeaksOK"}
						nok={"airLeaksNOK"}
						text={"airLeaksComment"}
						title={"There are no air leaks in the neumatic systems"}
						description={"Notify the plant maintenance department."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"materialGatesOK"}
						nok={"materialGatesNOK"}
						text={"materialGatesComment"}
						title={"The material gates have no damage"}
						description={
							"Check for visible damage and open and close gates to ensure proper operation."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"oilCompressorOK"}
						nok={"oilCompressorNOK"}
						text={"oilCompressorComment"}
						title={"The oil compressor level is correct"}
						description={
							"Refill oil if necessary and report to the maintenance department."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"airCompressorPressureOK"}
						nok={"airCompressorPressureNOK"}
						text={"airCompressorPressureComment"}
						title={"Check air compressor pressure"}
						description={"The pressure should be between 125 - 130 psi."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"plantDispensesOK"}
						nok={"plantDispensesNOK"}
						text={"plantDispensesComment"}
						title={"The plant dispenses water correctlybandRotates"}
						description={
							"Check water dispensing from the computer systembandRotates."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"bandRotatesOK"}
						nok={"bandRotatesNOK"}
						text={"bandRotatesComment"}
						title={"he band rotates properly"}
						description={"Rotate band from computer system."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"chemicaLevelOK"}
						nok={"chemicaLevelNOK"}
						text={"chemicaLevelComment"}
						title={"The chemical level is correct to start the shift"}
						description={
							"If the level is low, report to the appropriate personnel to request chemicals."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"reviewVibratorsOK"}
						nok={"reviewVibratorsNOK"}
						text={"reviewVibratorsComment"}
						title={"Review Vibrators"}
						description={"Check vibrators activate correctly."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"cementGateOK"}
						nok={"cementGateNOK"}
						text={"cementGateComment"}
						title={"Check Cement Gate"}
						description={"Check cement gates are open."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"reviewChillersOK"}
						nok={"reviewChillersNOK"}
						text={"reviewChillersTemperature"}
						title={"Review Chillers"}
						description={
							"Check chillers are on and place the temperature in comments."
						}
						type={"temperature"}
					/>
					<ItemChecked
						ok={"humidityProcessOK"}
						nok={"humidityProcessNOK"}
						text={"humidityProcessPercentage"}
						title={"Humidity Process"}
						description={
							"The process of capturing humidity was carried out and capturing humidity in the comment column."
						}
						type={"percentage"}
					/>
					<ItemChecked
						ok={"gravelHumidityOK"}
						nok={"gravelHumidityNOK"}
						text={"gravelHumidityTemperature"}
						title={"Gravel Humidity"}
						description={
							"Carry out the process to verify the humidity of the gravel."
						}
						type={"temperature"}
					/>
				</Row>
				<Title
					level={4}
					type="danger"
					style={{ paddingBottom: 20, paddingTop: 20 }}
				>
					POST
				</Title>
				<Row gutter={16}>
					<ItemChecked
						ok={"silotopFiltersOK"}
						nok={"silotopFiltersNOK"}
						text={"silotopFiltersComment"}
						title={"Silotop Filters"}
						description={"Check if it requires cleaning or changing filters."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"airTankPurgeOK"}
						nok={"airTankPurgeNOK"}
						text={"airTankPurgeComment"}
						title={"Air Tank Purge"}
						description={
							"Drain tanks until verifying that they do not contain water."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"bandConditionOK"}
						nok={"bandConditionNOK"}
						text={"bandConditionComment"}
						title={"Band In Good Condition"}
						description={
							"Adjust the band and check if it has any breaks or wear."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"verificationGallonsOK"}
						nok={"verificationGallonsNOK"}
						text={"verificationGallonsComment"}
						title={"Verification of gallons of water dispensed"}
						description={
							"Compare water dispensing with what it shows in the software."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"checkbeltrollerUrlsOK"}
						nok={"checkbeltrollerUrlsNOK"}
						title={"Check Belt Rollers"}
						description={"Check if the belt rollers are turning properly."}
						type={"images"}
						images={"checkbeltrollerUrls"}
						form={form}
					/>
					<ItemChecked
						ok={"accumulatedmaterialUrlsOK"}
						nok={"accumulatedmaterialUrlsNOK"}
						text={"accumulatedmaterialUrlsComment"}
						title={"Accumulated Material"}
						description={
							"Verification of accumulated materials (sand and cement) in the boots."
						}
						type={"images"}
						images={"accumulatedmaterialUrls"}
						form={form}
					/>
					<ItemChecked
						ok={"cleaningresidueUrlsOK"}
						nok={"cleaningresidueUrlsNOK"}
						text={"cleaningresidueUrlsComment"}
						title={"Cleaning aggregate residue from below the belt"}
						description={"Clean at the end of each shift."}
						type={"images"}
						images={"cleaningresidueUrls"}
						form={form}
					/>
					<ItemChecked
						ok={"checkLubricationOK"}
						nok={"checkLubricationNOK"}
						text={"checkLubricationComment"}
						title={"Check if it has enough grease"}
						description={"Check if it has enough grease."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"checkVibratorsOK"}
						nok={"checkVibratorsNOK"}
						text={"checkVibratorsComment"}
						title={"Check Vibrators"}
						description={
							"Verify that the vibrators work by activating them in the software."
						}
						type={"comment"}
					/>
					<ItemChecked
						ok={"airCompressorsOK"}
						nok={"airCompressorsNOK"}
						text={"airCompressorsComment"}
						title={"Air Compressors"}
						description={"Check that air compressors are working properly."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"checkWorkLightsOK"}
						nok={"checkWorkLightsNOK"}
						text={"checkWorkLightsComment"}
						title={"Check Work Lights"}
						description={"There is enough lighting to work at night."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"sandVolumeOK"}
						nok={"sandVolumeNOK"}
						text={"sandVolumeQuantity"}
						title={"Sand Volume"}
						description={"Do sand inventory and write quantity."}
						type={"quantity"}
					/>
					<ItemChecked
						ok={"gravelVolumeOK"}
						nok={"gravelVolumeNOK"}
						text={"gravelVolumeQuantity"}
						title={"Gravel Volume"}
						description={"Do gravel inventory and write quantity."}
						type={"quantity"}
					/>
					<ItemChecked
						ok={"cementVolumeOK"}
						nok={"cementVolumeNOK"}
						text={"cementVolumeQuantity"}
						title={"Cement Volume"}
						description={"Do cement inventory and write quantity."}
						type={"quantity"}
					/>
					<ItemChecked
						ok={"fullCementSilosOK"}
						nok={"fullCementSilosNOK"}
						text={"fullCementSilosComment"}
						title={"Full Cement Silos"}
						description={"Fill cement silos."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"functionalSlumpRackOK"}
						nok={"functionalSlumpRackNOK"}
						text={"functionalSlumpRackComment"}
						title={"Functional Slump Rack"}
						description={"Check that the water lines are functional."}
						type={"comment"}
					/>
					<ItemChecked
						ok={"chemicaInventoryOK"}
						nok={"chemicaInventoryNOK"}
						text={"chemicaInventoryComment"}
						title={"Admix Inventory"}
						description={"Review each of the chemicals and write the amount."}
						type={"comment"}
					/>
					<Row gutter={16} style={{ paddingBottom: 20, paddingTop: 20 }}>
						<ItemInventory value={"nr"} label={"NR"} />
						<ItemInventory value={"se"} label={"SE"} />
						<ItemInventory value={"sika440"} label={"SIKA 440"} />
						<ItemInventory value={"sika500"} label={"SIKA 500"} />
						<ItemInventory value={"sika1000"} label={"SIKA 1000"} />
					</Row>
					<Title level={5} style={{ paddingBottom: 20 }}>
						Material Consumption
					</Title>
					<Row gutter={16}>
						<Form.List name={"cogsPost"}>
							{(fields) => (
								<>
									{fields.map(({ key, name, ...restField }) => {
										const unitOfConversion = form.getFieldValue([
											"cogsPost",
											name,
											"unitOfConversion",
										]);
										return (
											<Col span={24}>
												<Row
													key={key}
													gutter={16}
													align="middle"
													style={{ marginBottom: 12 }}
												>
													<Col span={16}>
														<Form.Item
															{...restField}
															name={[name, "material"]}
															style={{ marginBottom: 0 }}
														>
															<Input readOnly size="large" />
														</Form.Item>
													</Col>

													<Col span={8}>
														<Form.Item
															{...restField}
															name={[name, "quantity"]}
															style={{ marginBottom: 0 }}
														>
															<Input
																size="large"
																readOnly
																suffix={<span>{unitOfConversion ?? "--"}</span>}
															/>
														</Form.Item>
													</Col>
												</Row>
											</Col>
										);
									})}
								</>
							)}
						</Form.List>
					</Row>
				</Row>
			</Form>
		);
	};

	return (
		<>
			{contextHolder}
			{loadingButton ? <CustomSpinner /> : <CustomForm />}
		</>
	);
};

export default ProductionCheckInView;

const ItemChecked = ({
	ok,
	nok,
	text,
	title,
	description,
	type,
	images,
	form,
}) => {
	const [visibleIndex, setVisibleIndex] = useState(-1);

	return (
		<Col span={24}>
			<Row gutter={16} justify={"space-between"}>
				<Col span={8}>
					<Row>
						<Col span={24}>
							<Text strong>{title}</Text>
						</Col>
						<Col span={24} seco>
							<Text strong type="secondary">
								{description}
							</Text>
						</Col>
					</Row>
				</Col>
				<Col span={8}>
					{text && type !== "images" && (
						<Form.Item name={text}>
							{type === "comment" && text !== "chemicaInventoryComment" && (
								<Input.TextArea size="large" readOnly />
							)}
							{type === "percentage" && (
								<Input size="large" suffix={"%"} readOnly />
							)}
							{type === "temperature" && (
								<Input size="large" suffix={"°F"} readOnly />
							)}
							{type === "quantity" && (
								<Input size="large" suffix={"TON"} readOnly />
							)}
						</Form.Item>
					)}
					{type === "images" && (
						<Form.List name={images}>
							{(fields) => (
								<>
									<Image.PreviewGroup
										preview={{
											visible: visibleIndex !== -1,
											current: visibleIndex,
											onVisibleChange: (vis) => !vis && setVisibleIndex(-1),
										}}
									>
										<Row justify={"start"} align={"top"}>
											{fields.map((field, index) => {
												const imageUrl = form.getFieldValue([images, index]);
												const nameImage = imageUrl.split("/")[6];
												return (
													<Col key={field.key} style={{ margin: 0 }} span={24}>
														{imageUrl && (
															<>
																<Image
																	src={imageUrl}
																	style={{ display: "none" }}
																/>

																<Text
																	underline
																	style={{
																		cursor: "pointer",
																		color: "#1890ff",
																	}}
																	onClick={() => setVisibleIndex(index)}
																>
																	{nameImage} {index + 1}
																</Text>
															</>
														)}
													</Col>
												);
											})}
										</Row>
									</Image.PreviewGroup>
								</>
							)}
						</Form.List>
					)}
				</Col>
				<Col>
					<Row gutter={16}>
						<Col>
							<Form.Item name={ok} valuePropName="checked">
								<Checkbox style={{ pointerEvents: "none" }}></Checkbox>
							</Form.Item>
						</Col>
						<Col>
							<Form.Item name={nok} valuePropName="checked">
								<Checkbox style={{ pointerEvents: "none" }}></Checkbox>
							</Form.Item>
						</Col>
					</Row>
				</Col>
			</Row>
		</Col>
	);
};

const ItemInventory = ({ value, label }) => {
	return (
		<Col span={8}>
			<Form.Item name={value} label={label}>
				<Input size="large" suffix={"GAL"} readOnly />
			</Form.Item>
		</Col>
	);
};
